import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import Flex from '@jarvis.oddle/core/components/Flex'
import IconTriangle from '@jarvis.oddle/core/components/Icons/IconTriangle'
import { H4, P } from '@jarvis.oddle/core/components/Typo'
import Form, { useFormContext } from '@jarvis.oddle/core/components/Form'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import useAppSelector from '../../../hooks/useAppSelector'

const StyledLabel = styled(P)`
  position: absolute;
  top: 0;
  font-weight: 400;
  font-size: 11px !important;
  line-height: 12px !important;
  color: #bbbbbb;
`

const StyledText = styled(H4)`
  margin: 21px 11px 8px 0;
  padding-top: 3px;
  color: #000;
`

const StyledOption = styled.option`
  padding-left: 20px;
  background: #F1F1F1;
`

const TimeSlotsDropdown = (): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const { values } = useFormContext()
  const timeSlots = useAppSelector((state) => state['@reservation'].timeslot.data) || []

  return (
    <Form.Select
      name='slot'
      options={timeSlots}
      Icon={IconTriangle}
      labelFormatter={option => moment(option, 'HH:mm:ss').format('h:mm A')}
      renderSelected={(option) => {
        return (
          <Flex>
            <StyledLabel>{t('Timeslot')}</StyledLabel>
            <StyledText>
              {moment(option, 'HH:mm:ss').format('h:mm A')}
            </StyledText>
          </Flex>
        )
      }}
      valueFormatter={(option) => option}
      CustomOption={StyledOption}
      selectedOption={values.slot}
    />
  )
}

export default TimeSlotsDropdown
